var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(typeof _vm.item.if !== 'undefined' && _vm.item.if)?_c('v-list-item',{attrs:{"href":_vm.item.href,"to":_vm.item.to}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.title))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }